import BarChart from 'components/charts/barChart';
import events from 'lib/events';
import moment from 'moment';
import PrintableFullReport from '../../components/printableFullReport';
import React from 'react';
import ReportApi from 'api/report';
import {dateTimeFormats} from 'helpers/constants';
import {formatStaticCurrency} from 'helpers/currencyHelper';
import {formatCurrency} from 'helpers/dashboardFormatter';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import SummarySectionPOSDate from '../../components/summarySectionPosDate.jsx';

class TotalAnalysesSummary extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {};

  export = () => {
    let filters = this.props.filters;

    ReportApi.getWaterTotalAnalysesExport(
      this.props.intl.locale,
      filters.dateFrom,
      filters.dateTo,
      filters.branch,
      filters.systemType
    );
  };

  printReport = (data) => {
    let columns;
    let {formatMessage} = this.props.intl;
    const {filters, tableData, POSActive} = this.props;

    if (POSActive) {
      columns = [
        {name: formatMessage({id: 'general.total.analyses'}), key: 'Analyses'},
        {name: formatMessage({id: 'general.total.bioguard.purchases'}), key: 'BioGuardPurchases'},
        {name: formatMessage({id: 'reports.average.analysis.account'}), key: 'AverageAnalysis'},
        {name: formatMessage({id: 'reports.average.purchase.analysis'}), key: 'AveragePurchase'},
      ];
      data.AveragePurchase = formatStaticCurrency(data.AveragePurchase);
    } else {
      columns = [
        {name: formatMessage({id: 'general.total.analyses'}), key: 'Analyses'},
        {name: formatMessage({id: 'reports.average.analysis.account'}), key: 'AverageAnalysis'},
      ];
    }

    const tableColumns = [
      {name: formatMessage({id: 'general.analyses.date'}), key: 'name'},
      {name: formatMessage({id: 'general.number.analyses'}), key: 'value'},
    ];

    return (
      <PrintableFullReport
        end={moment(filters.dateFrom).format(dateTimeFormats.numeralDate)}
        endLabel={formatMessage({id: 'general.end.date'})}
        formatMessage={formatMessage}
        start={moment(filters.dateTo).format(dateTimeFormats.numeralDate)}
        startLabel={formatMessage({id: 'general.start.date'})}
        summaryColumns={columns}
        summaryData={data}
        tableColumns={tableColumns}
        tableData={data.GraphValues}
        title={formatMessage({id: 'general.total.water.analyses'})}/>
    );
  };

  render() {
    let data = this.props.data;
    let noData = Object.keys(data).length <= 0;
    let chart;
    let {formatMessage} = this.props.intl;

    if (data.GraphValues && data.GraphValues.length > 0) {
      chart = <BarChart data={data.GraphValues}
                        verticalAxisTitle={formatMessage({id: 'general.number.analyses'})}
                        colors={['#75C7ED', '#33A9DE']}
                        gridThickness={0}
                        customLabelColor={true}
                        fillAlphas={.7}
                        columnWidth={.2}
      />;
    }

    return (
      <div>
        <div className="summary-container">
          <h2><FormattedMessage id="reports.report.summary"/></h2>
          <span className={noData ? 'not-show' : 'summary-date'}> | <FormattedMessage id="general.date.range.labelled" values={{
            start: this.props.filters && this.props.filters.dateFrom,
            end: this.props.filters && this.props.filters.dateTo,
          }}/>
          </span>
          <br/>
          <p>
            <FormattedMessage id="reports.reveal.report.summary"/>
          </p>
          <SummarySectionPOSDate POSActive={this.props.POSActive} dealer={this.props.dealer} />
          {this.props.showNoDataMessage ?
            <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
          <div className="container-fluid">
            <div className="row">
              <div className={noData ? 'not-show' : 'col-sm-3'}>
                <label><FormattedMessage id="general.total.analyses"/></label> <br/>
                <span>{data.Analyses}</span>
              </div>
              <div className={noData || !this.props.POSActive ? 'not-show' : 'col-sm-3'}>
                <label><FormattedMessage id="general.total.bioguard.purchases"/></label> <br/>
                <span>{data.BioGuardPurchases}</span>
              </div>
              <div className={noData ? 'not-show' : 'col-sm-3'}>
                <label><FormattedMessage id="reports.average.analysis.account"/></label> <br/>
                <span>{data.AverageAnalysis}</span>
              </div>
              <div className={noData || !this.props.POSActive ? 'not-show' : 'col-sm-3'}>
                <label><FormattedMessage id="reports.average.purchase.analysis"/></label> <br/>
                <span>{formatCurrency(data.AveragePurchase)}</span>
              </div>
            </div>
            <div className="row padding-bottom">
              <div className="col-sm-12">
                {chart}
              </div>
            </div>
          </div>
        </div>
        <div className='col-sm-12 button-group'>
          {/* <button className='btn btn-default pull-right'
                  disabled={noData}
                  onClick={(() => {
                    events.publish('print', this.printReport(data));
                  })}><FormattedMessage id="reports.print.summary"/></button> */}
          <button className='btn btn-primary pull-right'
                  onClick={this.export}><FormattedMessage id="reports.export.report"/></button>
        </div>
      </div>
    );
  }
}

export default injectIntl(TotalAnalysesSummary);
